import StantMultiselect from "../../utils/stant_multiselect.coffee"

$(document).on 'turbolinks:load', ->
  new StantMultiselect('entities-multiselect').add_listener()